import { stringLength } from "../string/StringHelper"

export const getLinksByText = ({ linksText }) => {
    try {
        const links = []

        if (linksText) {
            const linksSplit = linksText.split('\n')
            if (linksSplit && linksSplit.length > 0) {
                for (const link of linksSplit) {
                    links.push({
                        link: link,
                        shortLink: stringLength({ string: link, isDots: true })
                    })
                }
            }
        }

        return links
    } catch (e) {

    }
}